/**
 * Integridade da Cadeia de Valor — wizard público.
 *
 * O formulário é dirigido pela definition do backend
 * (GET /api/v1/assessments/value-chain-integrity/definition),
 * então reaproveita integralmente o wizard do IGA: mesma escala Likert,
 * mesma tela de consentimento LGPD, mesmo bloqueio de e-mail pessoal,
 * mesmo glossário e mesmo rascunho em localStorage.
 */
import AssessmentIGAPage from './AssessmentIGAPage'

export default function AssessmentValueChainPage() {
  return (
    <AssessmentIGAPage
      slug="value-chain-integrity"
      storageKey="nai_cadeia_valor_assessment_draft_v1"
      resultPath="/assessment/cadeia-de-valor/resultado"
      eyebrow="Nai Compliance Center · Integridade da Cadeia de Valor"
      title="Supplier Integrity Maturity Assessment"
    />
  )
}
